// @flow
import * as React from 'react';
import { getAddressString } from 'utils/address';
import { H4 } from 'components/Text';
import TrackedLink from 'components/TrackedLink';
import Link from 'components/Link';

const AddressLink = ({
  address,
  component,
  ...props
}: {
  address: Object,
  component?: React.ElementType
}) => {
  const Component = component || Link;
  return (
    <>
      {address.description && <H4 mb={0}>{address.description}</H4>}
      <Component
        href={`https://www.google.com/maps/search/?api=1&query=${encodeURI(
          getAddressString(address)
        )}`}
        target="_blank"
        {...props}
      >
        {getAddressString(address)}
      </Component>
    </>
  );
};

export const TrackedAddressLink = ({
  address,
  eventName,
  eventProperties,
  ...props
}: {
  address: Object,
  eventName: string,
  eventProperties?: Object
}) => (
  <AddressLink
    component={TrackedLink}
    address={address}
    eventName={eventName}
    eventProperties={eventProperties}
    {...props}
  />
);

export default AddressLink;
